<div class="sub-navigation chrome-no-repaint">
  <div class="container">
    <div class="row">
      <div class="col-10 pt-md-3 col-lg-11 position-relative">
        <groupchat-button
          [general]="true"
          [autoOpen]="true"
          label="Messages from Admins"
          class="d-xs-none d-md-block"></groupchat-button>
      </div>
    </div>
  </div>
</div>

<div class="container d-flex flex-column gap-4 pt-4 idea-rows-container">
  <idea-row
    row-title="Recently Added/Updated Projects"
    row-description="All the projects in all the topics you are a participant of"
    empty-message="No projects here? Head to topics and add the first!"
    [ideas]="recentIdeas"></idea-row>

  <!-- <idea-row
    row-title="Top Projects"
    row-description="Projects rated highest by the community, adjusted by number of votes"
    empty-message="No one has rated any project yet. Pick an project and vote for it!"
    [ideas]="topRatedIdeas"></idea-row> -->

  <idea-row
    row-title="Projects You Follow"
    [max-ideas]="256"
    empty-message="If you see an project that you like, click on the <span class='icon-star-empty'></span> button on the project's card to follow it."
    [ideas]="followedIdeas"></idea-row>

  <!-- <ng-container *ngIf="isAdmin">
    <br />
    <br />
    <button class="btn btn-primary" (click)="changeRecomTarget()">
      Change user
    </button>
    <ng-container *ngIf="recomTargetUser">
      <div
        style="
          display: inline-flex;
          align-items: center;
          vertical-align: super;
          margin-left: 16px;
        ">
        <profile-picture [user]="recomTargetUser"></profile-picture>
        <div style="margin-left: 8px">
          <name-tag [user]="recomTargetUser"></name-tag>
        </div>
      </div>
    </ng-container>
    <idea-row
      row-title="Recommended Projects"
      row-description="Projects specifically recommended for you"
      empty-message="Our system is still learning which projects might interest you, stay tuned!"
      [ideas]="recommendedIdeas"></idea-row>
  </ng-container> -->
</div>
